import React, { useContext, createContext, useState } from "react";
import { notification } from "antd"
import { PersonCreationData } from "../types/ServiceUserCreationTypes";
import { LookupListItems } from "../types/SubscriptionTypes";
import { Contact } from "../components/CreatePerson/Forms/TrustedContactsForm";
import { getLookupListByListName } from "../services/RegistrationService";

export type StateLookup = {
  value: string;
  label: string;
};

export const ServiceUserCreationContext = createContext<any | undefined>(
  undefined
);

export const useServiceUserCreationCtx = () =>
  useContext(ServiceUserCreationContext);

export const ServiceUserCreationProvider: React.FC = ({ children }) => {
  const [serviceUserMyselfDetails, setServiceUserMyselfDetails] = useState<
    PersonCreationData
  >();
  const [
    serviceUserSomeoneElseDetails,
    setServiceUserSomeoneElseDetails,
  ] = useState<PersonCreationData>();
  const [pageType, setPageType] = useState<string>("");
  const [isBackBtnClick, setIsBackBtnClick] = useState<boolean>(false);
  const [whoWillUseServices, setWhoWillUseServices] = useState<string>("");
  const [relationshipTypes, setRelationshipTypes] = useState<
    LookupListItems[]
  >();
  const [states, setStates] = useState<StateLookup[]>([]);
  const [contacts, setContacts] = useState<Contact[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  async function getRelationshipList() {
    try {
      let relationshipVal = await getLookupListByListName(
        1,
        "TrustedContactRelationships"
      );
      const relations = relationshipVal.map(
        (relation: { itemId: number; itemName: string }) => ({
          value: relation.itemId,
          label: relation.itemName,
        })
      );
      setRelationshipTypes(relations);
      return relations;
    } catch (error) {
      notification.error({
        message: "Failed to Fetch Relationships",
      });
    }
  }

  const getStateList = async () => {
    try {
      const stateDetails = await getLookupListByListName(
        1,
        "StateAbbreviations"
      );

      const stateList = stateDetails.map(
        (state: { itemId: number; itemName: string }) => ({
          value: state.itemName,
          label: state.itemName,
        })
      );
      setStates(stateList);
    } catch (error) {
      notification.error({
        message: "Failed to Fetch State List",
      });
    }
  };

  return (
    <ServiceUserCreationContext.Provider
      value={{
        serviceUserMyselfDetailsCtx: [
          serviceUserMyselfDetails,
          setServiceUserMyselfDetails,
        ],
        serviceUserSomeoneElseDetailsCtx: [
          serviceUserSomeoneElseDetails,
          setServiceUserSomeoneElseDetails,
        ],
        registrationBackBtnClickCtx: [isBackBtnClick, setIsBackBtnClick],
        whoWillUseServicesCtx: [whoWillUseServices, setWhoWillUseServices],
        relationshipTypesCtx: [relationshipTypes, setRelationshipTypes],
        pageTypeCtx: [pageType, setPageType],
        contactTcCtx: [contacts, setContacts],
        isLoadingCtx: [isLoading, setIsLoading],
        statesCtx: [states, setStates],
        getRelationshipList,
        getStateList
      }}
    >
      {children}
    </ServiceUserCreationContext.Provider>
  );
};
